import React from 'react';
import { useStyles } from '@webapps/styles';
import FileUpload from 'components/FileUpload';

export default function Step1() {
  const { classes } = useStyles(styles);

  return (
    <>
      <div className={classes.framerDiv11}>
        <div className={classes.framerP4}>Complète ton profil avec un CV</div>
        <div className={classes.framerP5}>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div>
      </div>
      <FileUpload />
    </>
  );
}

const styles = () => ({
  framerDiv11: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '100%',
    gap: '10px',
  },
  framerP4: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: '24px',
    fontWeight: '600',
    textAlign: 'left',
    color: '#152652',
    width: '100%',
    lineHeight: 'normal',
  },
  framerP5: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '15px',
    textAlign: 'left',
    color: '#5d75a8',
  },
}); 